<div class="container">

  <form #userForm="ngForm" (ngSubmit)="userForm.form.valid && onSubmit(userForm)">
    <div style="width:100%">
      <button type="button" (click)="toggleEdit()" [hidden]="!editmode" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-times"></i> Cancel</button>
      <button type="submit" [hidden]="!editmode" [disabled]="userForm.invalid" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-save"></i> Save</button>
      <button type="button" (click)="toggleEdit()" *hasClaim="'User_Edit'" [hidden]="editmode || editRole" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-pencil"></i> Edit</button>
    </div>
    <div>
      <div class="form-group">
        <label for="userName">User Name / Email</label>
        <input [hidden]="!editmode" id="userName" name="userName" class="form-control"
               required email
               [(ngModel)]="user.UserName" #userName="ngModel">
        <div *ngIf="userName.invalid && (userName.dirty || userName.touched)" class="alert alert-danger">
          <div *ngIf="userName.errors.required">
            required
          </div>
          <div *ngIf="userName.errors.email">
            must be a valid email address
          </div>
        </div>
        <div [hidden]="editmode">{{user.UserName}}</div>
      </div>
      <div class="form-row">
        <div class="form-group col-5">
          <label for="firstName">First Name</label>
          <input [hidden]="!editmode" id="firstName" name="firstName" class="form-control"
                 required
                 [(ngModel)]="user.FirstName" #firstName="ngModel">
          <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="alert alert-danger">
            <div *ngIf="firstName.errors.required">
              required
            </div>
          </div>
          <div [hidden]="editmode">{{user.FirstName}}</div>
        </div>
        <div class="form-group col-5">
          <label for="lastName">Last Name</label>
          <input [hidden]="!editmode" id="lastName" name="lastName" class="form-control"
                 required
                 [(ngModel)]="user.LastName" #lastName="ngModel">
          <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="alert alert-danger">
            <div *ngIf="lastName.errors.required">
              required
            </div>
          </div>
          <div [hidden]="editmode">{{user.LastName}}</div>
        </div>
      </div>
    </div>
  </form>
  <hr />
  <div [hidden]="editmode" class="shadowbox">
    <div class="row">
      <div class="col-6">
        <h4>Roles</h4>
      </div>
      <div class="col-6">
        <button type="button" (click)="toggleRoleEdit()" [hidden]="!editRole" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-times"></i> Cancel</button>
        <button type="button" (click)="saveRoles()" [hidden]="!editRole" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-save"></i> Save</button>
        <button type="button" (click)="toggleRoleEdit()" *hasClaim="'User_Edit'" [hidden]="editRole" class="float-right" style="margin-right:10px;margin-left:10px"><i class="fa fa-pencil"></i> Edit</button>
      </div>
    </div>
    <div [hidden]="editRole" *ngFor="let role of roles; index as i" class="childrow">
      <div class="childrowcol">{{role.Name}}</div>
    </div>
    <div [hidden]="!editRole" *ngFor="let role of roles; index as i" class="childrow">
      <div class="childrowdelete">
        <input id="is-active" type="checkbox" size="30" [(ngModel)]="role.UserHasThisRole" [style]="{'width':'400px'}">
      </div>
      <div class="childrowcol">{{role.Name}}</div>
    </div>
  </div>
</div>
<p-toast></p-toast>
